<template>
    <div>
        <Card :bordered="false" class="history-card">
        <p slot="title" class="card-title">
          <Icon type="ios-trash-outline" />
          Histori Hapus
        </p>

        <div class="filter-section">
          <Row type="flex" align="middle" :gutter="16">
            <Col :xs="24" :sm="24" :md="8" :lg="6">
              <div class="filter-item">
                <label class="filter-label">Marking</label>
                <Select
                  placeholder="Ketik Marking"
                  v-model="markingIdSelected"
                  filterable
                  clearable
                  remote
                  :remote-method="getMarkingByCode"
                  :loading="loadingGetMarking">
                  <Option
                    v-for="option in optionMarkings"
                    :value="option.value"
                    :key="option.value">
                    {{ option.label }}
                  </Option>
                </Select>
              </div>
            </Col>
            <Col :xs="24" :sm="24" :md="10" :lg="2">
              <div class="filter-item">
                <label class="filter-label">Branch</label>
                <Select
                    v-model="searchSelectSubbranch"
                    placeholder="Branchcode"
                    clearable
                    >
                    <Option v-for="subbranch, idx in subbranchs" :value="subbranch.subbranchcode" :key="idx">
                        {{ subbranch.subbranchname }}
                    </Option>
                </Select>
              </div>
            </Col>

            <Col :xs="24" :sm="24" :md="10" :lg="8">
              <div class="filter-item">
                <label class="filter-label">Periode</label>
                <DatePicker
                  v-model="dateFromTo"
                  type="daterange"
                  split-panels
                  placeholder="Pilih rentang tanggal"
                  style="width: 100%">
                </DatePicker>
              </div>
            </Col>

            <Col :xs="24" :sm="24" :md="6" :lg="4">
              <div class="filter-item">
                <label class="filter-label">&nbsp;</label>
                <Button
                  v-show="showSearchButton()"
                  type="primary"
                  long
                  :loading="loadingSearch"
                  @click="getPayment"
                  icon="ios-search">
                  <span>{{ loadingSearch ? 'Mencari...' : 'Cari' }}</span>
                </Button>
              </div>
            </Col>
          </Row>
        </div>

        <template v-if="payments.length > 0">
          <Divider style="margin: 0 0 16px" />
          <br />
          <div class="summary-bar">
            <span class="summary-label">Total Transaksi : </span>
            <Tag color="green" class="summary-tag">
              Rp {{ total | numberFormatted }}
            </Tag>
          </div>

          <Table
            :columns="tableColumns"
            :data="payments"
            no-data-text=""
            width="100%"
            ref="table"
            stripe
            :highlight-row="true">
          </Table>
        </template>

      </Card>
    </div>
</template>

<script>
import {HTTP} from '@/components/http-lib'
import _ from 'lodash'
import moment from 'moment'

const numeral = require('numeral');
export default {
    data: () => ({
        markingIdSelected : '',
        optionMarkings : [],
        loadingGetMarking: false,
        loadingSearch : false,
        payments : [],
        dateFromTo : [],
        subbranchcode: localStorage.getItem('user.subbranchcode'),
        searchSelectSubbranch: null,
        subbranchs: [],
        tableColumns: [
            { type: 'index', width: 60, align: 'center' },
            { title: 'Tgl. Pembayaran', key: 'paymentDate', minWidth: 75, sortable: false },
            { title: 'Marking', key: 'markingheadercode', minWidth: 75, sortable: true },
            { title: 'Nota Transaksi', key: 'transactionNote', minWidth: 100, sortable: true },
            { title: 'Jumlah', align: 'right', minWidth: 50, key: 'amount', sortable: false },
            { title: 'Detail', type: 'html', align: 'left',  minWidth: 300, key: 'description', sortable: false }, // <-- tanpa width, ini akan mengisi sisa
            { title: 'Tgl. Hapus', key: 'deleteAt', minWidth: 80, sortable: false },
            { title: 'Dihapus oleh', key: 'deletedBy', minWidth: 80, sortable: false },
        ],
        total: 0,
    }),

    methods: {
        getPayment: function(){
            this.loadingSearch = true;
            let dateCreateFrom =  moment(this.dateFromTo[0], 'YYYY-MM-DD', true)
            let dateCreateTo =  moment(this.dateFromTo[1], 'YYYY-MM-DD', true)

            let dateCreateFromValid = dateCreateFrom.isValid() == false ?  null : dateCreateFrom.format("YYYY-MM-DD");
            let dateCreateToValid = dateCreateTo.isValid() == false ?  null : dateCreateTo.format("YYYY-MM-DD");

            let payload = {
                markingHeaderId: this.markingIdSelected,
                dateDeleteFrom: dateCreateFromValid,
                dateDeleteTo: dateCreateToValid,
                branchcode : this.searchSelectSubbranch
            }

            console.log({payload});
            HTTP.post('payment/delete-history', payload)
            .then(response => {
                let parent = this;
                let payments = []
                parent.total = 0

                _.forEach(response.data, function(value) {
                    let payment = {
                        paymentDate : parent.showDateFormatted(value.paymentDate),
                        markingheadercode : value.marking_header.markingheadercode,
                        description : value.receivable.description,
                        transactionNote : value.pending != null ? value.pending.noteCode : '-',
                        amount : numeral(value.amount).format('0,0'),
                        deleteAt : value.created_at,
                        deletedBy : value.deletedBy,
                    }

                    payments.push(payment);
                    parent.total += value.amount;
                });

                this.payments =  payments;
                this.loadingSearch = false;

                if(payments.length == 0){
                    this.$Notice.warning({
                        title: 'Pembayaran Tidak Ditemukan',
                        desc: ''
                    });
                }
            })
            .catch(e => {
                this.loadingSearch = false;
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })
        },
        getSubbranch: function(){
                HTTP
                .get('subbranch')
                .then(response => {
                    this.subbranchs = response.data
                })
                .catch(e => {
                    //console.log(e);
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        getMarkingByCode: _.debounce(
            function (query) {

                if (query !== '') {
                    this.loadingGetMarking = true;
                    HTTP
                    .post('marking/getBySnapshot', {
                        markingHeaderId: query,
                        subbranchcode: this.subbranchcode
                    })
                    .then(response => {

                        this.invoiceDues = []
                        this.amountResidue = ''
                        this.amountReceived = ''
                        this.description = ''

                        this.loadingGetMarking = false;
                        let data = response.data;

                        const list = data.map(item => {
                            return {
                                value: item.markingheaderid,
                                label: item.markingheadercode
                            };
                        });

                        this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                    })
                    .catch(e => {
                        this.loadingGetMarking = false;
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                } else {
                    this.optionMarkings = [];
                }
            }, 400
        ),
        showDateFormatted : function(stringToFormat){
            let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
            return moment(dateToFormat).format("DD MMM YYYY")
        },
        showSearchButton: function(){
            // marking diisi atau tanggal diisi
            if ((this.markingIdSelected != '')  ||  ((this.dateFromTo[0] != '' && this.dateFromTo[0] != null))){
                return true
            }
            return false
        },
    },
    created() {
        this.getSubbranch();
    }
}

</script>
<style>
    .bold {
        font-weight: bold;
    }
    .red {
        color: red;
    }
</style>



// WEBPACK FOOTER //
// PaymentDeleteHistory.vue?7872a6b4